<div class="voice-bars form-control">
  @for (bar of bars; track bar) {
    <div
      class="bar"
    [ngStyle]="{
      'height.%': bar
    }"
    ></div>
  }
</div>
